"use client";

import * as LabelPrimitive from "@radix-ui/react-label";
import * as React from "react";

import { css, cva } from "@/../styled-system/css";

const label = cva({
  base: {
    textStyle: "sm",
    lineHeight: "none",
    fontWeight: "medium",
    _peerDisabled: {
      cursor: "not-allowed",
      opacity: "0.7",
    },
  },
});

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & { css?: object }
>(({ css: cssProp = {}, ...props }, ref) => {
  const className = css(label.raw(), cssProp);
  return <LabelPrimitive.Root ref={ref} className={className} {...props} />;
});
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
